import TargetJobStage from "../components/job-search-plan/stages/target-job-stage.vue";
import ResumeStage from "../components/job-search-plan/stages/resume-stage.vue";
import InterviewStage from "../components/job-search-plan/stages/interview-stage.vue";
import ApplyStage from "../components/job-search-plan/stages/apply-stage.vue";
import OfferStage from "../components/job-search-plan/stages/offer-stage.vue";

import TargetJobStageModal from "../modals/job-search-plan/stages/target-job-stage.vue";
import ResumeStageModal from "../modals/job-search-plan/stages/resume-stage.vue";
import InterviewStageModal from "../modals/job-search-plan/stages/interview-stage.vue";
import ApplyStageModal from "../modals/job-search-plan/stages/apply-stage.vue";
import OfferStageModal from "../modals/job-search-plan/stages/offer-stage.vue";

const PLAN_STEPS = {
    targetJobStage: "target-job-stage",
    resumeStage: "resume-stage",
    applyStage: "apply-stage",
    interviewStage: "interview-stage",
    offerStage: "offers-stage",
};

const COMPONENTS_MAP = {
    [PLAN_STEPS.targetJobStage]: {
        component: TargetJobStage,
        modal: TargetJobStageModal,
        title: "Target Job Stage",
        stepName: "target-job-stage",
        openFeatureLink: "job-tracker",
    },
    [PLAN_STEPS.resumeStage]: {
        component: ResumeStage,
        modal: ResumeStageModal,
        title: "Resume Stage",
        stepName: "resume-stage",
        openFeatureLink: "resumes",
    },
    [PLAN_STEPS.applyStage]: {
        component: ApplyStage,
        modal: ApplyStageModal,
        title: "Applying Stage",
        stepName: "applying-stage",
        openFeatureLink: "job-board-search",
    },
    [PLAN_STEPS.interviewStage]: {
        component: InterviewStage,
        modal: InterviewStageModal,
        title: "Interview Stage",
        stepName: "interview-stage",
        openFeatureLink: "interview-ai",
    },
    [PLAN_STEPS.offerStage]: {
        component: OfferStage,
        modal: OfferStageModal,
        title: "Offer Stage",
        stepName: "offer-stage",
        openFeatureLink: "learning-hub-course",
        openFeatureParam: "your-negotiating",
    },
};

const stepsArray = [...Object.values(COMPONENTS_MAP).flat()];

export { PLAN_STEPS, COMPONENTS_MAP, stepsArray };
